import cn from 'classnames';
import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { metadataIdFixer } from '@bibliocommons/utils-link';
import { bibJacketCoverAltText } from '@bibliocommons/utils-item';
import Rating from '@bibliocommons/rating';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import BibBrief from '@bibliocommons/shared-bib-brief';
import JacketCover from '@bibliocommons/shared-jacket-cover';
import BibSeries from '@bibliocommons/shared-bib-series';
import RecommendationsContainer from '../../../containers/RecommendationsContainer';
import ManifestationList from '../ManifestationList';

const propTypes = {
  availabilityDetail:   ImmutablePropTypes.map,
  item:                 ImmutablePropTypes.map,
  catalogSearchOptions: ImmutablePropTypes.map,
  branches:             ImmutablePropTypes.list,
  currentUser:          ImmutablePropTypes.map,
  showSeries:           PropTypes.bool
};

class SearchResultItemContent extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('renderManifestations');
  }
  renderSeries() {
    if (this.props.showSeries) {
      return (
        <span className="series-list">
          <p>
            <FormattedMessage id="series" />:
          </p>
          {this.props.item.getIn(['briefInfo', 'series']).valueSeq().map((series) => <BibSeries series={series} />)}
        </span>
      );
    }
    return null;
  }

  renderManifestations() {
    return (
      <ManifestationList
        availabilityDetail={this.props.availabilityDetail}
        availabilityBib={this.props.item.get('briefInfo')}
        availabilityDetailActions={this.props.availabilityDetailActions}
        manifestations={this.props.manifestations}
        catalogSearchOptions={this.props.catalogSearchOptions}
        currentUser={this.props.currentUser}
        groupSearchFeedbackActions={this.props.groupSearchFeedbackActions} />
    );
  }

  render() {
    const bibTitle = this.props.item.getIn(['briefInfo', 'title']);
    const bibCoverAltText = bibJacketCoverAltText(bibTitle, this.props.item.getIn(['briefInfo', 'authors']));
    const jacketSource = this.props.item.getIn(['briefInfo', 'jacket']);
    const manifestations = this.props.manifestations;
    const searchResultItemContentClasses = cn('cp-search-result-item-content');

    return (
      <div className={searchResultItemContentClasses}>
        <div className="cp-search-result-item-info">
          <div className="jacket-cover-wrap hidden-md hidden-lg">
            <a href={`/item/show/${metadataIdFixer(this.props.item.get('id'))}`} title={bibTitle} target="_parent">
              <JacketCover src={jacketSource} format={this.props.item.getIn(['briefInfo', 'format'])} alt={bibCoverAltText} />
            </a>
          </div>
          <div>
            <BibBrief bib={this.props.item.get('briefInfo')} renderAuthorsAsLink>
              {this.renderSeries()}
            </BibBrief>
            <Rating
              readOnly
              rating={this.props.item.getIn(['briefInfo', 'rating', 'averageRating']) || 0}
              id={`rating_${this.props.item.get('id')}`} />
          </div>
        </div>

        <div className="info">
          <div className="row">
            <div className="col-xs-12 availability_status">
              {this.renderManifestations()}
            </div>
          </div>
        </div>
        <RecommendationsContainer manifestations={manifestations} />
      </div>
    );
  }
}

SearchResultItemContent.propTypes = propTypes;

export default SearchResultItemContent;



// WEBPACK FOOTER //
// ./app/components/search/SearchResultItemContent/SearchResultItemContent.jsx